import './App.css';
import {Route, Routes} from "react-router-dom";
import HomePage from "./pages/HomePage";
import StraussInRedirect from "./pages/StraussInRedirect";

function App() {
    return (
        <Routes>
            <Route index element={<HomePage />} />
            <Route path='/strauss-in' element={<StraussInRedirect />} />
        </Routes>
    )
}

export default App;